import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Base64 } from 'js-base64';
import { createReq } from './payment-model-createReq.js';
@Component({
  selector: 'app-payment-model',
  templateUrl: './payment-model.component.html',
  styleUrls: [
    './payment-model.component.scss',
    './payment-model.component.rtl.scss',
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PaymentModelComponent implements OnInit, AfterViewInit {
  type: any = 'payment';
  public_key!: string;
  email!: string;
  phone_number!: string;
  tx_ref!: string;
  name!: string;
  currency!: string;
  url!: string;
  checkOutUrl!: string;
  amount: any;
  @Input() data: any;
  trustedHtmlContent: any;
  trustedUrl: any;
  html: any;
  html1: any;
  redirectUrl: any;
  paymentId = 'lzkWfuinnfxR8sGkgUBDGxMPB';
  sessionsID = 'SESSION0002079138177J4540000K28';
  merchantID = "TESTLAFARGE_W"
  locale: any;
  originUrl!: string;
  cartData: any;
  @ViewChild('container') containerRef!: ElementRef;
  highOrder: any;
  lowOrder: any;

  constructor(private sanitizer: DomSanitizer, private store: Store) {
    this.originUrl = window.location.origin;
  }

  ngOnInit(): void {
    console.log('Data', this.data);
console.log(    this.locale === 'ar-EG' && this.sessionsID && this.paymentId);

    this.store
      .select((state) => state)
      .subscribe((data: any) => {
        this.locale = data.authReducer.userDetails?.country?.locale;
        this.cartData = data?.cartReducer?.cartData;
      });
    this.redirectUrl = `${window.location?.origin}/processing`;
    this.type = this.data?.payment_providers?.name;
  }
  ngAfterViewInit() {
    this.type = this.data?.payment_providers?.name;
    this.public_key = this.data?.payment_providers?.key;
    this.email = this.data?.payment_data?.email;
    this.phone_number = this.data?.payment_data?.phone;
    this.tx_ref = this.data?.payment_data?.payment_id;
    this.name = this.data?.payment_data?.name;
    this.amount = this.data?.payment_data?.amount;
    this.currency = this.data?.payment_data?.currency;
    this.url = this.data?.payment_providers?.payment_gateway_url;
    this.checkOutUrl = this.data?.checkout_url;
    this.paymentId = this.data?.payment_data?.payment_id;
    this.sessionsID = this.data?.payment_data?.session_id;
    this.merchantID = this.data?.payment_providers?.merchant_id;
    localStorage.setItem("payment_id", this.paymentId)
    let formContent: any;
    if (this.type === 'paymongo') {
      formContent = `<form name="flutterwaveForm"
                      id="my-form"
                      method="post"
                      action='${this.checkOutUrl}'
                     >
                     <input type="hidden" value=${this.public_key} name="public_key" id="public_key"></input>
                     <input type="hidden" value=${this.email} name="customer[email]" id="email"></input>
                     <input type="hidden" value=${this.phone_number} name="customer[phone_number]" id="phone_number"></input>
                     <input type="hidden" value=${this.name} name="customer[name]" id="name"></input>
                     <input type="hidden" value=${this.tx_ref} name="tx_ref" id="tx_ref"></input>
                     <input type="hidden" value=${this.amount} name="amount" id="amount"></input>
                     <input type="hidden" value=${this.currency} name="currency" id="currency"></input>
                     <input type="hidden" value=${this.redirectUrl} name="redirect_url" id="redirect_url"></input>
                     </form>
                     `;
    } else if (this.locale === 'en-UG') {
      formContent = `<form name="flutterwaveForm" id="my-form"  method="post"  action='${this.url}' > 
      <input type="hidden" value=${this.public_key} name="public_key" id="public_key">
      </input>  <input type="hidden" value=${this.email} name="customer[email]" id="email">
      </input>  <input type="hidden" value=${this.phone_number} name="customer[phone_number]" id="phone_number">
      </input>  <input type="hidden" value=${this.name} name="customer[name]" id="name">
      </input>  <input type="hidden" value=${this.tx_ref} name="tx_ref" id="tx_ref"></input> 
       <input type="hidden" value=${this.amount} name="amount" id="amount"></input> 
        <input type="hidden" value=${this.currency} name="currency" id="currency"></input>  
        <input type="hidden" value=${this.redirectUrl} name="redirect_url" id="redirect_url"></input>
         </form> `;
    } else {
      formContent = `
                       <form name="paynamicForm"
                          method="post"
                          action='${this.url}'
    
                       >
    
                       <input type="hidden" value="${Base64.encode(
                         createReq(
                           this.data,
                           this.cartData.products,
                           this.cartData?.discount_Details?.discount_amount
                         )
                       )}" name="paymentrequest" id="paymentrequest"></input>
                       </form>
                         `;
    }
    setTimeout(() => {
      this.html = `
  <html lang="en">
  <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Payment Page</title>
      <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css" integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">
      <script type="text/javascript" src="https://js.stripe.com/v3/" ></script>
  </head>
  <body onload="${
    this.type !== 'paynamics'
      ? `document.flutterwaveForm.submit()`
      : `document.paynamicForm.submit()`
  }">
  ${formContent}
  <script>
  </script>
  </body>
  </html>`;
      this.trustedHtmlContent = this.sanitizer.bypassSecurityTrustHtml(
        this.html
      );
    });

    //Egypt
    // setTimeout(() => {
    //   this.html1 = `https://clickitapp.io/egyptPayment.html?session_id=${this.sessionsID}&order_id=${this.tx_ref}`;
    //   // this.html1 = `https://clickitapp.io`;

    //   this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    //     this.html1
    //   );
    // });
    setTimeout(() => {
      if (this.locale === 'ar-EG') {
        this.containerRef?.nativeElement.click();
      }
    }, 100);
  }
}
